export const SIGN_IN_STAFF_API = {
  url: `/api/staff_auth/sign_in`,
  method: 'post'
};
